export default __webpack_public_path__ + "static/media/BWHL.0fe25525.png";